interface Props {
  current: number
  total: number
}

/**
 * Stepper «Шаг N из M» — закрывает AC #2 US-E2-001.
 * Используется на всех шагах onboarding flow.
 */
export function Stepper({ current, total }: Props) {
  const percent = Math.min(100, Math.max(0, (current / total) * 100))
  return (
    <div role="progressbar" aria-valuemin={1} aria-valuemax={total} aria-valuenow={current} className="w-full">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-semibold uppercase tracking-wider text-text-secondary">
          Шаг {current} из {total}
        </span>
        <span className="text-xs text-text-secondary tabular-nums">
          {Math.round(percent)}%
        </span>
      </div>
      <div className="h-1 bg-surface-subtle rounded-full overflow-hidden">
        <div
          className="h-full bg-action-primary-bg transition-[width] duration-200"
          style={{ width: `${percent}%` }}
          aria-hidden
        />
      </div>
    </div>
  )
}
